<template>
    <v-card class="pa-5 kim-card">
        <v-card-text class="text-left pt-3 pb-1">
          <v-textarea
              v-model="stepsToFollow"
              rows="5"
              filled
              :loading="saving"
              placeholder="Escribe algo..."
              hide-details
          />
        </v-card-text>
    </v-card>
</template>

<script>

    import {debounce} from '@/utils/Common'
    import {ApiUtils} from '@/utils/ApiUtils'
    import {userProvides, OPHTHALMOLOGY} from '@/utils/Specialist'

    import {mapState} from 'vuex'


    export default{
        props: {
          readonly:{
            type: Boolean,
            default: false
          },
          eventId: {
            type: Number,
            required: true
          },
          steps:{
            type: String,
            default: ''
          }//'readonly', 'eventId', 'steps'
        },
        components:{},
        data(vm){
            return {
                saving: false,
                stepsToFollow: ''
            }
        },
        mounted(){
          const vm = this
          vm.setDefaults()
        },
        methods: {
            debouncedSave: debounce(function(){
              this.save()
            }, 1000),
            setDefaults(){
              const vm = this
              vm.stepsToFollow = vm.steps
            },
            async save(){

                var vm = this
                if (!vm.eventId) return

                vm.saving = true
                const response = await ApiUtils.makePost(`appointments/${vm.eventId}/steps`, {
                    steps: vm.stepsToFollow
                })
                vm.saving = false

                if (response.ok) {
                    const json = await response.json()
                    vm.$emit('change', vm.stepsToFollow)
                }
            }
        },
        computed: {
            ...mapState(['currentProvider']),
            userIsOphthalmologist(){
                return userProvides(OPHTHALMOLOGY)
            }

        },
        watch: {
            stepsToFollow(val){
                this.debouncedSave()
            },
            steps(){
              const vm = this
              vm.setDefaults()
            }
        }

    }



</script>
